var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
import { memo } from "react";
var SvgBeer = function SvgBeer(_ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "12px",
    height: "16px",
    "aria-hidden": "true",
    viewBox: "0 0 12 16",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Compliance-Checks",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "beer",
    transform: "translate(-2.000000, 0.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Filled_Icons",
    transform: "translate(2.666667, 0.000000)",
    fill: "currentColor",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.5786667,0.108 C10.5153333,0.04 10.4266667,0 10.3333333,0 L0.333333333,0 C0.239333333,0 0.150666667,0.04 0.0873333333,0.108 C0.024,0.177333333 -0.00733333333,0.269333333 0.00133333333,0.362666667 L1.33466667,15.696 C1.34933333,15.8686667 1.49333333,16 1.66666667,16 L9,16 C9.17266667,16 9.31733333,15.8686667 9.332,15.696 L10.6653333,0.362666667 C10.6733333,0.269333333 10.642,0.177333333 10.5786667,0.108 Z M9.564,5.33333333 L1.102,5.33333333 L0.696666667,0.666666667 L9.96933333,0.666666667 L9.564,5.33333333 Z",
    id: "Shape"
  })), /*#__PURE__*/React.createElement("g", {
    id: "invisible_shape"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-path",
    x: 0,
    y: 0,
    width: 16,
    height: 16
  }))))));
};
var Memo = /*#__PURE__*/memo(SvgBeer);
export { Memo as ReactComponent };
export default __webpack_public_path__ + "transfix-icons/icons/Beer.3c17e4205507e4096bc1fdd5c0297afb.svg";